import { version as e } from "react";
//#region src/utils/getReactElementRef.ts
var t = Number.parseInt(e, 10) >= 19, n = (e) => t ? e.props.ref : e.ref;
//#endregion
export { n as default };

//# sourceMappingURL=getReactElementRef.js.map